import React from 'react';
import ResponsiveWrapper from '../../components/ResponsiveWrapper';
import Product from './index';
import MobileProduct from './MobileProduct';

const ResponsiveProduct = () => {
  return (
    <ResponsiveWrapper
      mobile={<MobileProduct />}
      desktop={<Product />}
    />
  );
};

export default ResponsiveProduct;